const lang = {
    "Confirm Password":"Подтвердите пароль.",
    "Next":"Следующий",
    "Please enter a four-digit password.":"Пожалуйста, введите четырёхзначный пароль.",
    "That's the wrong password! Please re-enter.":"Это неправильный пароль! Пожалуйста, попробуйте ещё раз.",
    "Enter Password":"Введите пароль",
    "Please come back after checking.":"Пожалуйста, вернитесь после проверки.",
    "Please connect using the QR code.":"Пожалуйста, подключитесь с помощью QR-кода.",
    "Expired QR Code":"Недействительный QR-код",
    "Invalid access.":"Неверный доступ.",
    "An error has occurred.":"Произошла ошибка.",
    "Your data has been deleted.":"Ваши данные были удалены.",
    "To meet the new Virtual Smile, please request a new QR code.":"Чтобы попробовать свою новую виртуальную улыбку, пожалуйста запросите новый QR-код",
    "Complete Setup":"Полная установка",
    "To protect your privacy, you'll need to agree to use it and set a password.":"Чтобы защитить свои данные, необходимо согласиться с использованием конфиденциальности и установить пароль.",
    "entry.button.set_password":"Установить пароль",
    "Consent is required to set a password.":"Перед установкой пароля необходимо принять условия пользователя.",
    "I have received an explanation of the Ray Virtual Smile service by the hospital and understand the information provided.":"Настоящим я подтверждаю, что получил разъяснения относительно услуги Ray Virtual Smile и усвоил предоставленную информацию.",
    "I have been given the opportunity by the hospital to ask questions about Ray Virtual Smile service.":"Я обратился в клинику с запросом относительно услуги Ray Virtual Smile, и в ответ мне была предоставлена исчерпывающая информация.",
    "I voluntarily agree the proposed use of data in sharing.":"Настоящим я даю разрешение на передачу моих персональных данных клинике.",
    "I agree that managing this password is solely my responsible.":"Настоящим я подтверждаю понимание и принятие на себя ответственности за управление моими данными вышеупомянутым сервисом.",
    "I understand I can withdraw at any time without giving reasons and without being questioned, and that I will not be penalized for withdrawing.":"Я понимаю, что могу отозвать это согласие в любое время, обратившись в клинику.",
    "Consent":"Разрешить ",
    "Set Password":"Установить пароль",
    "Please enter 4 numbers for your password.":"Пожалуйста, введите четырёхзначный пароль.",
    "Confirm Password.":"Подтвердите пароль.",
    "Please enter your password again.":"Пожалуйста, введите свой пароль ещё раз.",
    "Please wait for a moment.":"Пожалуйста, подождите минутку.",
    "Enter password":"Введите пароль",
    "Please enter your password.":"Пожалуйста, введите свой пароль.",
    "The connection was rejected due to an abnormal access.":"Связь была отклонена из-за неправильного доступа.",
    "Setting":"Настройки",
    "Language":"Язык",
    "Delete All Items":"Удалить все данные",
    "Are you sure you want to delete? Erased data cannot be recovered.":"Вы уверены, что хотите продолжить? После удаления данные будет невозможно восстановить.",
    "Please enter your password to delete the data.":"Необходимо ввести пароль для подтверждения удаления данных.",
    "This data was deleted by requesting of user.":"Данные были удалены по запросу пользователя.",
    "Make sure RAYTeams is logged in.":"Убедитесь, что RAYTeams вошёл в систему.",
    "\"Ray Virtual Smile\" could not be found, please create new one.":"Не удалось найти Ray Virtual Smile. Пожалуйста, создайте новый.",
    "Data uploads are delayed due to poor network connectivity":"Загрузка данных задерживается из-за плохого подключения к сети.",
    "Confirm":"Подтвердить",
    "Delete":"Удалить",
};

const trans = {
    ...lang,
}

export default trans;